import React from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";

function NotesWrapper({
  openQuickEditMode,
  onInputHandleQuickEditChange,
  activeExercise,
  notesInputRef,
}) {
  const { t } = useTranslation("dashboard");
  if (!openQuickEditMode && !activeExercise.notes) return null;
  return (
    <div className="exnotes">
      <SvgIcon src="/img/new-icons/message-icon.svg" />
      {openQuickEditMode ? (
        <textarea
          ref={notesInputRef}
          id={`${activeExercise._id}_notes`}
          name="notes"
          defaultValue={activeExercise.notes ? activeExercise.notes : ""}
          onInput={onInputHandleQuickEditChange}
          className="textarea-input-notes"
          placeholder={t("notesWrapper.enterNotesHere")}
        />
      ) : (
        <p className="p2">{activeExercise.notes}</p>
      )}
    </div>
  );
}

export default NotesWrapper;
